<PageContainer>
	<div class="mb-8">
		Pokud při objednávání služeb upřednostňujete osobní kontakt, můžete navštívit některého z našich
		obchodních partnerů.
	</div>

	<div class="mb-8">
		<img src={porovnejsitoLogo} alt="porovnejsito.cz" width="300" height="89" /><H2
			>porovnejsito.cz</H2
		><a href="https://www.porovnejsito.cz/">https://porovnejsito.cz/</a>
	</div>

	<div class="mb-8 grid grid-cols-2 gap-6 lg:grid-cols-4">
		<div>
			<H2>JOPC</H2>

			<p>
				Bratislavská č. 2
				<br />
				<strong>Ústí nad Labem</strong>
			</p>

			<p>
				<a href="https://www.jopc.cz/" target="_blank" rel="noopener noreferrer">www.jopc.cz</a>
			</p>
		</div>
		<div>
			<H2>JH Soft s.r.o.</H2>
			<p>Palackého 1231<br /><strong>Vodňany</strong></p>
			<p><a href="https://www.jhs.cz/" target="_blank" rel="noopener noreferrer">www.jhs.cz</a></p>
		</div>
		<div>
			<H2>Orion Computer</H2>
			<p>Na Ohradě 417<br /><strong>Strakonice</strong></p>
			<p>
				<a href="https://orionco.cz/" target="_blank" rel="noopener noreferrer">www.orionco.cz</a>
			</p>
		</div>
	</div>

	<div class="mb-8 grid grid-cols-2 gap-6 lg:grid-cols-4">
		<div>
			<H2>Mobilman</H2>
			<p>Pražská 39<br /><strong>Znojmo</strong></p>
			<p>
				<a href="https://mobilman.ekatalog.biz/" target="_blank" rel="noopener noreferrer"
					>mobilman.cz</a>
			</p>
		</div>
		<div>
			<H2>Zenes</H2>
			<p>Hvězdová 1730/23<br /><strong>Znojmo</strong></p>
			<p><a href="https://zenes.cz/" target="_blank" rel="noopener noreferrer">zenes.cz</a></p>
		</div>
	</div>

	<p>
		Velkoobchodní ceník ke stažení <a
			data-sveltekit-reload
			href={asset('download/cenik_velkoobchodni.pdf')}>zde</a>

		.
	</p>
</PageContainer>

<script lang="ts">
	import porovnejsitoLogo from '#lib/assets/images/other/porovnejsito-300x89.png';
	import PageContainer from '#lib/components/layout/PageContainer.svelte';
	import H2 from '#lib/components/ui/H2.svelte';
	import { resolve, asset } from '$app/paths';
</script>
